import React from 'react';
import PageHelmet from '../../common/page-helmet/page-helmet.component';
import Header from '../../common/header/header.component';
import { Link } from 'react-router-dom';
import Footer from '../../common/footer/footer.component';

const InternalServerError500 = () => {
  const title = '500 Internal Server Error';

  return (
    <>
      <PageHelmet pageTitle={title}/>
      <Header/>

      <div className="error-page-inner">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="inner">
                <h1 className="title theme-gradient">500</h1>
                <h3 className="sub-title text-body">Internal Server Error</h3>
                <span className="text-body">Please try again later.</span>
                <div className="error-button">
                  <Link to="/" className="rn-button-style--2 btn-solid">Back To Homepage</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer/>
    </>
  );
};

export default InternalServerError500;
